import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ProfileService } from '../services/profile.service';
import { I18nService } from '../services/i18n.service';
import { isSystemAdmin } from '../utils/roles';

export const adminGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const profile = inject(ProfileService);
  const router = inject(Router);
  const i18n = inject(I18nService);

  await auth.whenReady;

  if (!auth.isAuthenticated()) {
    // Preserve the attempted deep link through login (Bug #840656, D-2), for
    // parity with authGuard.
    return router.createUrlTree(['/'], { queryParams: { returnUrl: state.url } });
  }

  if (!profile.profile()) {
    profile.fetchProfile();
  }
  await profile.whenProfileReady;

  const p = profile.profile();
  if (p && isSystemAdmin(p.role)) {
    return !i18n.syncStoredLanguage(p.languageId, state.url);
  }

  return router.parseUrl('/');
};
